export default "__VITE_ASSET__DgCxa_yq__"